export default {"src":"/_next/static/media/email_white_icon.dde92dcf.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};